export default {
      id: "Icon--exoticEscapee-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--exoticEscapee",
      toString: function () {
        return this.url;
      }
    }